import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRow } from '../../repositories/mortgage-broker-calculator/entities/mortgage_listing/Row';
import { ILandingState, ICalculatorMcfValues, IAuthorizedModal, TCalculatorMcfErrorsItem } from 'shared/types/features';

export const initialState: ILandingState = {
  isModalOpen: false,
  modalWindowContent: null,
  authorizedModal: {
    isOpen: false,
  },
  calculatorValues: null,
  calculatorErrors: [],
};

/* istanbul ignore next */
export const landingSlice = createSlice({
  initialState,
  name: 'landing',
  reducers: {
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setAuthorizedModal: (state, action: PayloadAction<IAuthorizedModal>) => {
      state.authorizedModal.isOpen = action.payload.isOpen;
      state.authorizedModal.pathForRedirect = action.payload.pathForRedirect;
      state.authorizedModal.bankName = action.payload.bankName;
      state.authorizedModal.typeForRedirect = action.payload.typeForRedirect;
    },
    setCalculatorValues: (state, action: PayloadAction<ICalculatorMcfValues>) => {
      state.calculatorValues = action.payload;
    },
    setCalculatorErrors: (state, action: PayloadAction<TCalculatorMcfErrorsItem[]>) => {
      state.calculatorErrors = action.payload;
    },
    resetCalculatorErrors: state => {
      state.calculatorErrors = [];
    },
    resetCalculatorValues: state => {
      state.calculatorValues = null;
    },
    setModalContent: (state, action: PayloadAction<IRow[] | null>) => {
      state.modalWindowContent = action.payload;
    },
  },
});

export const {
  setModalOpen,
  setAuthorizedModal,
  resetCalculatorValues,
  resetCalculatorErrors,
  setCalculatorErrors,
  setCalculatorValues,
  setModalContent,
} = landingSlice.actions;
